import windowsZones from 'cldr-core/supplemental/windowsZones.json';

/**
 * Timezone id normalization for calendar walks.
 *
 * RDrive calendars store Windows timezone ids ("W. Europe Standard Time" —
 * the API's timezone list is TimeZoneInfo.GetSystemTimeZones()), which
 * Intl.DateTimeFormat does not accept. This resolves either an IANA id
 * (passed through) or a Windows id (mapped through CLDR's windowsZones, the
 * same table snagr-helper-timezone uses in the main web app) to an IANA id
 * Intl can evaluate, or null when neither works.
 */
const windowsToIana = {};
windowsZones.supplemental.windowsZones.mapTimezones.forEach(({ mapZone }) => {
  // The territory-001 row comes first per Windows id and names the canonical
  // zone; other rows may list several space-separated zones.
  if (!windowsToIana[mapZone._other]) {
    windowsToIana[mapZone._other] = String(mapZone._type || '').split(' ')[0];
  }
});

const resolved = new Map();

function intlAccepts(id) {
  try {
    new Intl.DateTimeFormat('en-US', { timeZone: id });
    return true;
  } catch {
    return false;
  }
}

/**
 * @param {string} id - IANA or Windows timezone id
 * @returns {string|null} an IANA id Intl accepts, or null
 */
export function toIanaTimeZone(id) {
  if (!id || typeof id !== 'string') return null;
  const cached = resolved.get(id);
  if (cached !== undefined) return cached;

  let result = null;
  if (intlAccepts(id)) {
    result = id;
  } else {
    const mapped = windowsToIana[id];
    if (mapped && intlAccepts(mapped)) result = mapped;
  }
  resolved.set(id, result);
  return result;
}
